import { PokerFaceSpecialOfferPrice } from './Button';
import { SpecialOfferProps } from '../types';
import {
  Product,
  ProductsContainer,
  StyledFrame,
  StyledSpecialOffer,
} from './style';
import { DefaultSaleBadge } from 'components/Badge/Sale/DefaultSaleBadge';
import { EBadgePosition, EBadgeType } from 'utils/enums';
import { EBadgeDesignType } from 'components/Badge/types';
import { Box } from '@mui/system';
import { generateSalePercentageBasedOnType } from 'utils';
import { isMobileOnly } from 'react-device-detect';

export const PokerFaceSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  buttonColor,
  buttonTextColor,
  borderColor,
  productsList,
  availability,
  backgroundColor,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  collectText,
  timer,
  availabilityText,
}) => {
  const availabilityDescription =
    availability?.remaining && availability?.total && availabilityText
      ? `${availabilityText} ${availability.remaining}/${availability.total}`
      : '';

  return (
    <StyledFrame
      borderColor={borderColor}
      onClick={selectOffer}
      isMobileView={isMobileOnly}
      data-testid={dataTestId}
    >
      <StyledSpecialOffer backgroundColor={backgroundColor}>
        <div className="frame">
          {salePercentage > 0 && (
            <Box className="badge-wrapper">
              <DefaultSaleBadge
                salePercentage={salePercentage}
                position={EBadgePosition.TOP}
                text={`${generateSalePercentageBasedOnType(
                  salePercentage,
                  salePercentageDisplayType,
                )} MORE`}
                designType={EBadgeDesignType.MIDDLE}
                type={EBadgeType.SALE}
                salePercentageDisplayType={salePercentageDisplayType}
              />
            </Box>
          )}
          <ProductsContainer
            backgroundImage={backgroundImage}
            borderColor={backgroundColor?.colorOne}
          >
            {productsList.map((product) => {
              return (
                <Product
                  key={product.name}
                  data={product}
                  className="communix-products"
                >
                  <Box className="communix-products--image">
                    <img
                      className="image"
                      src={product.images.product}
                      alt="product"
                    />
                  </Box>
                  <span className="communix-products--amount">
                    {product.quantityDisplay}
                  </span>
                </Product>
              );
            })}
          </ProductsContainer>
          <div className="price-container">
            <PokerFaceSpecialOfferPrice
              prices={prices}
              buttonColor={buttonColor}
              buttonTextColor="white"
              borderColor={backgroundColor?.colorOne}
              isFree={isFree}
              buttonText={collectText}
            />
            {timer && (
              <span className="price-container-text timer">
                Ends in {timer}
              </span>
            )}
            {availabilityDescription && (
              <span className="price-container-text quantity">
                {availabilityDescription}
              </span>
            )}
          </div>
        </div>
      </StyledSpecialOffer>
    </StyledFrame>
  );
};
